import { Loader2 } from "lucide-react";

/** Полноэкранный индикатор загрузки (пока выясняем сессию при старте). */
export function FullscreenLoader({ label = "Загрузка…" }: { label?: string }) {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-bg text-muted"
      role="status"
      aria-live="polite"
    >
      <span className="inline-flex items-center gap-2">
        <Loader2 size={18} className="animate-spin" aria-hidden="true" />
        {label}
      </span>
    </div>
  );
}
